import './src/css/main.css'
import { wrapMDX } from './root-mdx'

export const wrapRootElement = wrapMDX
